module.exports = __webpack_public_path__ + "static/media/3DPPA28.02fea0d1.jpg";